import { z } from 'zod';

/**
 * Admin database diagnostics schemas
 * Used for database health monitoring and statistics
 */

// Database table statistics
export const DatabaseTableStatsSchema = z.object({
  tableName: z.string(),
  rowCount: z.number().int().nonnegative(),
  diskSize: z.string().optional(),
  indexSize: z.string().optional(),
});

export type DatabaseTableStats = z.infer<typeof DatabaseTableStatsSchema>;

// Database overview stats response
export const DatabaseStatsResponseSchema = z.object({
  tables: z.array(DatabaseTableStatsSchema),
  totalSize: z.string().optional(),
  databaseName: z.string().optional(),
  timestamp: z.date(),
});

export type DatabaseStatsResponse = z.infer<typeof DatabaseStatsResponseSchema>;

// Twitter data diagnostics
export const TwitterDiagnosticsResponseSchema = z.object({
  counts: z.object({
    profiles: z.number().int().nonnegative(),
    tweets: z.number().int().nonnegative(),
    tweetsWithMedia: z.number().int().nonnegative(),
    followEdges: z.number().int().nonnegative(),
    followSnapshots: z.number().int().nonnegative(),
    followSnapshotMembers: z.number().int().nonnegative(),
    followEvents: z.number().int().nonnegative(),
    profileInteractions: z.number().int().nonnegative(),
  }),
  latestSnapshot: z
    .object({
      id: z.string(),
      type: z.enum(['followers', 'following']),
      observerProfileId: z.string(),
      itemCount: z.number().int().nonnegative(),
      complete: z.boolean(),
      createdAt: z.date(),
    })
    .nullable(),
});

export type TwitterDiagnosticsResponse = z.infer<typeof TwitterDiagnosticsResponseSchema>;
